import styles from './product-version-grid.module.scss';
import { ValueFormatterParams } from 'ag-grid-community';
import { useState } from 'react';
import { useGetRequestNewHook } from '../../requestUtils';
import { CreateHeaders, HeaderSizeEnum, Icon, MenuItem, PrimaryButton, SecondaryButton, Select, textHeader } from '@frontend-workspace/react-shared-lib';
import AddNewVersionDialog from '../add-new-version-dialog/add-new-version-dialog';
import EditVersionDialog from '../edit-version-dialog/edit-version-dialog';
import DeleteVersionDialog from '../delete-version-dialog/delete-version-dialog';
import { IRelationProductsVersions } from '../../_models/relation-products-versions';
import { IRelationProduct } from '../../_models/relation-product';
import { WebkuaTable } from '@frontend-workspace/webkua-lib';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ProductVersionGridProps { }

export function ProductVersionGrid(props: ProductVersionGridProps) {
  const { t } = useTranslation();
  const [selectedProductId, setSelectedProductId] = useState<string | undefined>(undefined);
  const [addNewVersion, setAddNewVersion] = useState<boolean>(false);
  const [editVersionId, setEditVersionId] = useState<string | undefined>(undefined);
  const [deleteVersionId, setDeleteVersion] = useState<string | undefined>(undefined);

  const { data: relationProductsVersions, getData }: { data: IRelationProductsVersions, getData: () => void } = useGetRequestNewHook(`relationProducts/${selectedProductId}/versions`, { versions: [] }, [selectedProductId]);
  const { data: products } = useGetRequestNewHook(`relationProducts/action/getIdsOfProductsWithVersion`, []);
  const { data: relationProducts }: { data: IRelationProduct[] } = useGetRequestNewHook(`relationProducts`, []);
  const relationProductOptions = relationProducts.filter(p => products.includes(p.id)).map(p => { return { value: p.id, label: p.productName } });

  const handleProductChange = (event: any) => setSelectedProductId(event.target.value);

  const openAddNewVersionDialog = () => setAddNewVersion(true);
  const closeAddNewVersionDialog = () => setAddNewVersion(false);

  const openEditVersionDialog = (e: string) => setEditVersionId(e);
  const closeEditVersionDialog = () => setEditVersionId(undefined);

  const openDeleteVersionDialog = (e: string) => setDeleteVersion(e);
  const closeDeleteVersionDialog = () => setDeleteVersion(undefined);

  const editVersion = relationProductsVersions.versions.find(v => v.id === editVersionId);
  const deleteVersion = relationProductsVersions.versions.find(v => v.id === deleteVersionId);

  const editVersionRenderer = (params: ValueFormatterParams) => (
    <PrimaryButton
      variant="outlined"
      size='small'
      onClick={() => openEditVersionDialog(params.value)}>
      {t("standard.changeVersion")}
    </PrimaryButton>
  );

  const deleteVersionRenderer = (params: ValueFormatterParams) => (
    <SecondaryButton
      variant="outlined"
      size='small'
      onClick={() => openDeleteVersionDialog(params.value)}>
      {t("standard.deleteVersion")}
    </SecondaryButton>
  );

  const filesRenderer = (params: ValueFormatterParams) => {
    return params.value.length;
  }

  const headers = CreateHeaders([
    textHeader("versionName", t("productVersionGrid.versionName"), HeaderSizeEnum.SMALL),
    textHeader("files", t("productVersionGrid.numberOfFiles"), HeaderSizeEnum.SMALL, {
      renderer: filesRenderer,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    textHeader("id", "", HeaderSizeEnum.LARGE, {
      renderer: editVersionRenderer,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"

    }),
    textHeader("id", "", HeaderSizeEnum.LARGE, {
      renderer: deleteVersionRenderer,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
  ]);
  console.log(editVersion, selectedProductId);
  return <>
    <div className="d-flex flex-row align-items-end flex-wrap">
      <div className="mb-3 mb-xxl-0 me-5">
        <Select
          displayEmpty
          value={selectedProductId || ''}
          onChange={handleProductChange}
          fullWidth
          sx={{ width: '300px' }}
          label={t("standard.selectProduct")}
          name='product'>
          {relationProductOptions?.map(p => (
            <MenuItem key={p.value} value={p.value}>{p.label}</MenuItem>
          ))}
        </Select>
      </div>
      <div className="mb-3 mb-xxl-0">
        <PrimaryButton
          variant="contained"
          onClick={openAddNewVersionDialog}
          disabled={!selectedProductId}
          className='minButtonWidth'>
          <Icon className="me-1" fontSize="small">add</Icon>{t("standard.newVersion")}
        </PrimaryButton>
      </div>
    </div>
    <WebkuaTable
      headers={headers}
      data={relationProductsVersions?.versions}
    />
    {selectedProductId &&
      <AddNewVersionDialog
        open={!!addNewVersion}
        onClose={closeAddNewVersionDialog}
        relationProductId={selectedProductId}
        getData={getData}
      />}
    {editVersion && selectedProductId &&
      <EditVersionDialog
        open={!!editVersionId}
        onClose={closeEditVersionDialog}
        getData={getData}
        version={editVersion}
        versionGroupId={relationProductsVersions.id}
        relationProductId={selectedProductId}
        lastReleaseId={relationProductsVersions?.lastRelease ? relationProductsVersions?.lastRelease.id : undefined}
      />}
    {deleteVersion &&
      <DeleteVersionDialog
        open={!!deleteVersionId}
        onClose={closeDeleteVersionDialog}
        version={deleteVersion}
        getData={getData}
        versionGroupId={relationProductsVersions.id}
      />}
  </>;
}

export default ProductVersionGrid;